//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      statuses: constant.traders.REQUISITE_TYPE_LIST,
      localSearchString: '',
      filters: {
        searchString: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        currency: [],
        paymentMethods: [],
        status: [],
      },
    };
  },

  mounted() {
    const { requisiteId } = this.$route.query;

    if (requisiteId) {
      this.$router.replace({ query: {} });
      this.localSearchString = requisiteId;
      this.filters = {
        ...this.filters,
        searchString: requisiteId,
      };
    }
  },

  computed: {
    ...mapState('tradersRequisites', ['filterLists']),

    ...mapState('tradersCurrencies', { currencies: 'data' }),
    ...mapState('tradersPaymentMethods', { paymentMethods: 'data' }),
    ...mapState('usersGroups', ['groups']),

    roles() {
      return [
        { caption: 'Trader', id: 0 },
        { caption: 'Merchant', id: 3 },
      ];
    },
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('tradersRequisites', ['setFilters']),

    handleSearchBlur() {
      this.filters.searchString = this.localSearchString;
    },
  },
};
